import React from "react";
import hero from "../../assets/testimonialHero.png";
import "./Testimotail.css";
import { TestimonialsData } from "../../data/testimonials";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper";

const Testimonial = () => {
  return (
    <div>
      <div className="testimonial-container">
        
        <div className="testimonial-text left">
          <h2 className="h2">TOP RATED</h2>
          <p>
            SEEDILY SAY HAS SUITABLE DISPOSAL AND BOY EXERCISE JOY MAN CHILDREN
            REJOICED.
          </p>
        </div>

        <div className="testimonial-image">
          <img src={hero} alt="Happy Customer" />
        </div>

        <div className="testimonial-text right">
          <h2>100K</h2>
          <p>HAPPY CUSTOMERS WITH US</p>
        </div>
      </div>

      <div className="reviews-container">
        <h2 className="reviews-title">REVIEWS</h2>
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={2} 
          navigation={false}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          breakpoints={{
            480: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {TestimonialsData.map((review , i) => (
            <SwiperSlide key={i} className="review-card">
              <div className="review-content">
                <img
                  src={review.image}
                  alt={review.name}
                  className="review-avatar"
                />
                <p className="review-text">{review.comment}</p>
                <hr className="review-line" />
                <h4 className="review-name">{review.name}</h4>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonial;
